import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=ece7b0c4&scoped=true&lang=pug&"
import script from "./BookingDetail.vue?vue&type=script&lang=ts&"
export * from "./BookingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=ece7b0c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece7b0c4",
  null
  
)

export default component.exports